import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { CustomerEditDialogComponent } from 'src/app/ReusableComponent/editCustomer/customerEdit.component';
import { custFilterData, CustomerList, CustomerViewModel } from 'src/app/service/customer.model';
import { MemberService } from 'src/app/service/member.service';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { CityViewModel, StateViewModel } from 'src/app/service/state.model';
import { VendorService } from 'src/app/service/vendor.service';
import { environment } from 'src/environments/environment';
import { Constant, NumberOfEntriesToShow, RoleName } from '../../@shared/constants/Constant';
import { CustomerService } from '@services/customer.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css'],
})
export class CustomerListComponent implements OnInit, AfterViewInit, OnDestroy {
  private _subscription = new Subscription();
  order = '';
  customerList: CustomerViewModel[] = [];
  sortBy = 'name';
  sortOrder = false;
  selectedCustomerItem: CustomerList[] = [];
  selectedState: any = [];
  selectCity: any = [];
  searchText = '';
  limit: number;
  cities: CityViewModel[] = [];
  StateList: StateViewModel[] = [];
  selectedValue = 3;
  cityDropdownSettings = {};
  numberOfEntries = NumberOfEntriesToShow;
  isMobileDevice = true;
  customerNameList: CustomerList[] = [];
  currentPage = 1;
  pageSize = 10;
  selectedPage = 10;
  totalCount: number;
  pagination: string;
  responsive: any;
  url = `${environment.baseUrl}`;
  headerName: string;
  isCustomerEdit: boolean;
  customer = {};
  selectedIndex: number;
  dropdownSettings = {};
  dropdownSettingsForName = {};
  user: ILoggedInUserViewModel;
  loader = true;
  isInternalReadOnly = false;
  id: number;
  fromPage: string;
  dataFilter: custFilterData = {
    customerName: [],
    city: [],
    state: [],
    isShowAllCustomers: false,
    searchString: '',
    limit: this.selectedPage,
    OffsetValue: 1,
  };
  showAll = false;
  name = false;
  primaryContact = false;
  emergencyContact = false;
  phone = false;
  email = false;
  type = false;

  constructor(
    private router: Router,
    private customerService: CustomerService,
    private _memberService: MemberService,
    private vendorService: VendorService,
    private _serviceRequestService: ServiceRequestService,
    private _dialog: MatDialog,
  ) {
    this.getCustomersList();
    this.getCityList();
    this.getStateList();
    this.applyFilter();
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'stateId',
      textField: 'stateName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
    };
    this.cityDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'cityName',
      itemsShowLimit: 2,
      allowSearchFilter: true,
    };
    this.dropdownSettingsForName = {
      singleSelection: false,
      idField: 'customerID',
      textField: 'customerName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
    };
    this.isMobileDevice = mobileDeviceCheck();
  }

  ngAfterViewInit(): void {
    this.searchCustomer();
  }

  getCustomersList() {
    if (this._memberService.customerList$.value.length > 0) {
      this.customerNameList = this._memberService.customerList$.value;
    } else {
      this._memberService.getCustomerList().subscribe(
        (response) => {
          this.customerNameList = [...response].map((customer) => ({ ...customer }));
        },
        () => {
          this.loader = false;
        },
      );
    }
  }

  getCityList() {
    this.vendorService.getCityList().subscribe(
      (response) => {
        this.cities = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getStateList() {
    this.vendorService.getStateList().subscribe(
      (response) => {
        this.StateList = response;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  selectedPageCurrent() {
    this.limit = this.selectedPage;
    this.currentPage = 1;
    this.applyFilter();
  }

  currentPageChange() {
    this.applyFilter();
  }

  openAddCustomer(addName, value) {
    this.customer = {};
    this.headerName = addName;
    this.isCustomerEdit = value;
    this.openAddEditCustomerDialog();
  }

  openEditCustomer(editName, value, customerList, index) {
    this.customerService.fetchCustomerListById(index).subscribe((response) => {
      this.customer = response;
      if (this.customer['region'] == null) {
        this.customer['region'] = '';
      }
      if (this.customer['poBox'] != null && this.customer['poBox'] !== undefined && this.customer['poBox'] !== '') {
        this.customer['poBox'] = JSON.parse(this.customer['poBox']);
      }
      this.selectedIndex = index;
      this.headerName = editName;
      this.openAddEditCustomerDialog();
    });
  }

  disableCustomer(index, event) {
    this.loader = true;
    this.vendorService.getVendorDetailEnable(event.target.checked, index).subscribe((response) => {
      this.applyFilter();
    });
  }

  openVendorDetailPage(customerId) {
    this.fromPage = 'customer';
    this.id = customerId;
    this.router.navigate(['/common-details/' + this.fromPage + '/' + this.id]);
  }

  applyFilter() {
    this.loader = true;
    this.dataFilter = {
      customerName: this.selectedCustomerItem.map((x) => x.customerName),
      city: this.selectCity.map((x) => x.cityName),
      state: this.selectedState.map((x) => x.stateName),
      searchString: this.searchText,
      isShowAllCustomers: this.showAll,
      limit: this.selectedPage,
      OffsetValue: this.currentPage,
    };
    this.getCustomerList();
  }

  searchCustomer() {
    const searchInput = document.getElementById('searchInput');
    if (searchInput) {
      this._subscription.add(
        fromEvent(searchInput, 'input')
          .pipe(debounceTime(1000))
          .subscribe((searchTextResponse) => {
            this.currentPage = 1;
            this.dataFilter = {
              customerName: this.selectedCustomerItem.map((x) => x.customerName),
              city: this.selectCity.map((x) => x.cityName),
              state: this.selectedState.map((x) => x.stateName),
              searchString: (searchTextResponse.target as HTMLInputElement).value.trim() || '',
              isShowAllCustomers: this.showAll,
              limit: this.limit,
              OffsetValue: this.currentPage,
            };
            this.getCustomerList();
          }),
      );
    }
  }

  private getCustomerList() {
    this.loader = true;
    this.customerService.getFilterData(this.dataFilter).subscribe(
      (response) => {
        this.totalCount = response.count;
        this.customerList = response.customerDetails;
        this.loader = false;
        this.pagination = Constant.showPaginationMessage(this.totalCount, this.currentPage, this.selectedPage);
      },
      (error) => {
        console.log(error);
        this.loader = false;
      },
    );
  }

  clearFilter(): void {
    this.initializeCustomerFilter();
    this.selectedCustomerItem = [];
    this.selectCity = [];
    this.selectedState = [];
    this.currentPage = 1;
    this.applyFilter();
  }

  initializeCustomerFilter(): void {
    this.dataFilter = {
      customerName: [],
      city: [],
      state: [],
      isShowAllCustomers: false,
      searchString: '',
      limit: this.selectedPage,
      OffsetValue: 1,
    };
    this.searchText = '';
  }

  showAllCustomer(): void {
    this.loader = true;
    this.showAll = !this.showAll;
    this.dataFilter.isShowAllCustomers = !this.dataFilter.isShowAllCustomers;
    this.currentPage = 1;
    this.applyFilter();
  }

  openAddEditCustomerDialog(): void {
    const dialogRef = this._dialog.open(CustomerEditDialogComponent, {
      position: {
        top: '5rem',
      },
      width: '60rem',
      disableClose: true,
      data: {
        header: this.headerName,
        customerDetail: this.customer,
        index: this.selectedIndex,
      },
    });
    dialogRef.afterClosed().subscribe((response: string) => {
      if (response === 'refresh') {
        this.applyFilter();
      }
    });
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
